// extracted by mini-css-extract-plugin
module.exports = {"staff_header":"StaffAndRoles_staff_header__FbEBJ","title":"StaffAndRoles_title__adFyj","staff_search":"StaffAndRoles_staff_search__1F3e-","search":"StaffAndRoles_search__2t5xZ"};